import { useRef, useState } from 'react';

import { apiRequest } from '../../services/api';

type Props = {
  uploadPath?: string;
  onUploaded: (data: { storageKey: string; mimeType?: string }) => void;
  accept?: string;
  label?: string;
};

export default function ElearningFileUpload({
  uploadPath = '/admin/elearning/upload',
  onUploaded,
  accept = 'video/mp4,video/webm,application/pdf,image/*',
  label = 'Téléverser un fichier',
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string | null>(null);

  async function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const form = new FormData();
      form.append('file', file);
      const res = await apiRequest(uploadPath, { method: 'POST', withAuth: true, body: form });
      setFileName(file.name);
      onUploaded({ storageKey: res.data.storageKey, mimeType: res.data.mimeType });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Upload échoué');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  }

  return (
    <div className="space-y-2">
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handleChange} />
      <button
        type="button"
        disabled={busy}
        onClick={() => inputRef.current?.click()}
        className="academic-panel-btn academic-panel-btn--secondary w-full !justify-center"
      >
        {busy ? 'Téléversement…' : label}
      </button>
      {fileName ? <p className="text-xs text-emerald-700">Fichier : {fileName}</p> : null}
      {error ? <p className="text-xs text-red-700">{error}</p> : null}
    </div>
  );
}
